import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { addEvItem } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { CartItemDTO, ShoppingCartDTO } from '@t/api.types';

interface UseAddEvItemOptions {
  onSuccess?: (cart: ShoppingCartDTO) => void;
  onError?: (error: Error) => void;
}

export const useAddEvItem = (
  sessionId: string,
  { onSuccess, onError }: UseAddEvItemOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, CartItemDTO> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, CartItemDTO>({
    mutationFn: (item) => addEvItem(sessionId, item),
    onSuccess: (cart) => {
      queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart);
      onSuccess?.(cart);
    },
    onError,
  });
};
